import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { TripPlace, TripPlaceSort } from '../../lib/types/models/trip-places/trip-places'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripPlaces(input: PaginationRequest<never, never, never, TripPlaceSort> = {}) {
  if (!input.sort) input.sort = { label: 'asc' }
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.tripPlaces.getAll.url, null), input))
    .get<PaginationResponse<TripPlace>>()
}
